"use client";

import { useEffect } from "react";
import { useSearchParams, usePathname, useRouter } from "next/navigation";
import { useWelcomeModal } from "../hooks/useWelcomeModal";

/**
 * When user lands on /?welcome=1 (e.g. after email confirmation), opens the welcome modal
 * and replaces URL with / so the param is not visible.
 */
export function WelcomeModalFromUrl() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();
  const { open } = useWelcomeModal();

  useEffect(() => {
    if (pathname !== "/") return;
    if (searchParams.get("welcome") !== "1") return;

    open();
    router.replace("/", { scroll: false });
  }, [pathname, searchParams, open, router]);

  return null;
}
